/* ============================================================================
 *  siteConfig.js — AMIB FIGURA 1 (Promotor de Fondos de Inversión - Serie 100)
 * ============================================================================ */

export const siteConfig = {
  saasKey: "amib-figura1",
  brand: {
    name: "AMIBFigura1",
    namePrefix: "AMIB",
    nameSuffix: "Figura1",
    subBrand: "by MIVX",
    tagline:
      "La plataforma líder en preparación para el examen AMIB Figura 1 (Promotor de Fondos de Inversión, Serie 100) en México.",
    flagEmoji: "🇲🇽",
    madeInLabel: "Hecho en México",
    locale: "es-MX",
    timezone: "America/Mexico_City",
  },

  niche: {
    professionLabel: "Promotor de Fondos de Inversión",
    aspirantLabel: "Aspirante a Figura 1",
    country: "México",
    authority: "AMIB / CNBV",
    phonePlaceholder: "+52 55 0000 0000",
    flagshipLaw: "Serie 100 — Programa Oficial de Certificación AMIB",
  },

  contact: {
    supportEmail: "go@mivx.com",
    salesEmail: "go@mivx.com",
  },

  payment: {
    // Lien de paiement Stripe (produit prod_UgBEzOPHECRGfm, MX$249/mes)
    checkoutUrl: "https://buy.stripe.com/fZu5kC1Bi1kd97o1SX0co03",
    portalUrl: "",
    cancelSubscriptionEndpoint:
      "https://ssulldqbxelavhyptweu.supabase.co/functions/v1/cancelar-suscripcion",
    providerName: "Stripe",
  },

  api: {
    geminiModel: "gemini-2.5-flash-preview-09-2025",
    aiErrorFallback:
      "No se pudo conectar con el Tutor IA. Por favor, intenta más tarde.",
  },

  seo: {
    title:
      "AMIBFigura1 — Simulador del Examen AMIB Figura 1 (Serie 100) Promotor de Fondos de Inversión",
    description:
      "Aprueba el examen AMIB Figura 1 a la primera con +2,000 reactivos tipo Serie 100, simulador tipo examen oficial y explicación detallada en cada pregunta. Cobertura completa: ética, LMV, fondos, deuda, capitales, derivados, PLD/FT y valuación.",
    keywords:
      "examen amib figura 1, serie 100 amib, promotor fondos inversion, simulador amib serie 100, certificacion amib mexico, aprobar figura 1 amib, reactivos amib, simulacro figura 1 amib, pld bursatil mexico, lmv cnbv",
    author: "AMIBFigura1",
    domain: "examenfigura1.com",
    canonicalUrl: "https://examenfigura1.com/",
    ogImage: "/og-image.png",
    ogTitle: "Simulador Examen AMIB Figura 1 — Serie 100",
    ogDescription:
      "+2,000 reactivos con explicación detallada y simulador tipo examen oficial para aprobar tu Figura 1 a la primera. Construido sobre la regulación CNBV, AMIB y el temario oficial Serie 100.",
    schemaCourseName: "Curso de Preparación Examen AMIB Figura 1 (Serie 100)",
    schemaCourseDescription:
      "Plataforma de simulación, temario y banco de reactivos con explicación detallada para el examen oficial de Promotor de Fondos de Inversión, alineada al programa AMIB Serie 100.",
  },

  colors: {
    primary: "#059669",
    primaryDark: "#047857",
    accent: "#10b981",
    primaryTw: "emerald-600",
    primaryTwHover: "emerald-700",
    primaryTwLight: "emerald-50",
    primaryTwBorder: "emerald-200",
    primaryTwText: "emerald-700",
    secondaryTw: "teal-600",
    secondaryTwLight: "teal-50",
    accentTw: "emerald-500",
    gradientFrom: "from-emerald-600",
    gradientTo: "to-teal-700",
  },

  stats: [
    { value: "+2k", label: "Reactivos tipo Serie 100" },
    { value: "9", label: "Módulos del temario oficial" },
    { value: "∞", label: "Simulacros tipo examen oficial ilimitados" },
    { value: "24/7", label: "Acceso multi-dispositivo" },
  ],

  hero: {
    badge: "Simulador tipo examen oficial Serie 100",
    titleLine1: "Aprueba a la primera y conviértete en",
    titleLine2: "Promotor de Fondos de Inversión",
    subtitle:
      "Más de 2,000 reactivos tipo Serie 100, simulador tipo examen oficial AMIB y explicación detallada en cada respuesta. Domina la LMV, los fondos de inversión, PLD/FT y la valuación a tu propio ritmo.",
    primaryCta: "Comienza gratis",
    secondaryCta: "Hacer examen de prueba",
    secondaryCtaBadge: "Gratis",
  },

  features: {
    sectionEyebrow: "Características",
    sectionTitle: "Todo lo que necesitas para aprobar Figura 1",
    sectionSubtitle:
      "Plataforma construida exclusivamente para el examen AMIB Serie 100, con cobertura íntegra del temario oficial y herramientas pensadas para el ritmo del aspirante mexicano.",
    items: [
      {
        title: "Temario Oficial Serie 100",
        description:
          "9 módulos completos: ética, marco legal LMV, economía, fondos de inversión, mercado de deuda, capitales y derivados, perfil del inversionista, PLD/FT y matemáticas financieras.",
        color: "from-emerald-500 to-teal-500",
        iconPath:
          "M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.747 0 3.332.477 4.5 1.253v13C19.832 18.477 18.247 18 16.5 18c-1.746 0-3.332.477-4.5 1.253",
      },
      {
        title: "Simulador Real",
        description:
          "Mismo formato, número de reactivos y dificultad de la Serie 100. Temporizador, ponderación por módulo y calificación instantánea como en el examen oficial.",
        color: "from-emerald-500 to-teal-500",
        iconPath:
          "M9.75 17L9 20l-1 1h8l-1-1-.75-3M3 13h18M5 17h14a2 2 0 002-2V5a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z",
      },
      {
        title: "Práctica por Tema",
        description:
          "Refuerza un módulo a la vez: LMV, fondos, derivados, PLD/FT o valuación. Practica donde tienes huecos y avanza a tu ritmo.",
        color: "from-teal-500 to-cyan-500",
        iconPath:
          "M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-3 7h3m-3 4h3m-6-4h.01M9 16h.01",
      },
      {
        title: "Explicación en Cada Pregunta",
        description:
          "Cada reactivo incluye una explicación detallada que cita la regulación aplicable: LMV, LFI, DCG de la CNBV y Código de Ética AMIB.",
        color: "from-purple-500 to-pink-500",
        iconPath:
          "M8 10h.01M12 10h.01M16 10h.01M9 16H5a2 2 0 01-2-2V6a2 2 0 012-2h14a2 2 0 012 2v8a2 2 0 01-2 2h-5l-5 5v-5z",
      },
      {
        title: "Estadísticas Avanzadas",
        description:
          "Visualiza tu progreso por módulo, identifica fortalezas y áreas a reforzar antes del examen oficial. Sabes exactamente qué estudiar después.",
        color: "from-orange-500 to-red-500",
        iconPath:
          "M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z",
      },
      {
        title: "Actualización Constante",
        description:
          "Reactivos y temario alineados a las últimas disposiciones de la CNBV, Banxico y AMIB. Estudias con la versión vigente del programa Serie 100.",
        color: "from-green-500 to-emerald-500",
        iconPath: "M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z",
      },
    ],
  },

  demo: {
    sectionEyebrow: "Ponte a prueba hoy",
    sectionTitlePart1: "Simulador Real del",
    sectionTitlePart2: "Examen AMIB Serie 100",
    sectionSubtitle:
      "Vive el formato y la dificultad del examen oficial AMIB Figura 1 en menos de 5 minutos. Sin registro ni tarjeta.",
    bullets: [
      { label: "Reactivos Reales Serie 100", icon: "📈" },
      { label: "Cronómetro", icon: "⏱️" },
      { label: "Calificación Instantánea", icon: "📊" },
      { label: "Explicación en cada pregunta", icon: "💡" },
    ],
    ctaLabel: "Hacer examen de prueba",
    ctaBadge: "¡GRATIS!",
    questions: [
      {
        q: "¿Cuál es la autoridad reguladora del mercado de valores en México?",
        o: [
          "Banco de México (Banxico)",
          "Comisión Nacional Bancaria y de Valores (CNBV)",
          "Secretaría de Hacienda y Crédito Público (SHCP)",
          "Servicio de Administración Tributaria (SAT)",
        ],
        c: 1,
        exp: "La CNBV regula y supervisa al sistema financiero, incluyendo el mercado de valores y la distribución de fondos de inversión.",
      },
      {
        q: "¿Qué es un fondo de inversión?",
        o: [
          "Una cuenta bancaria con rendimiento garantizado",
          "Un instrumento que capta recursos del público para invertirlos en una cartera diversificada de valores",
          "Un crédito al consumo de corto plazo",
          "Un seguro de vida con componente de inversión",
        ],
        c: 1,
        exp: "Los fondos de inversión captan recursos del público inversionista para invertir en valores conforme a un régimen específico.",
      },
      {
        q: "El prospecto de información al público inversionista debe estar disponible:",
        o: [
          "Solo para clientes institucionales",
          "Únicamente al momento de liquidar",
          "Permanentemente al público inversionista",
          "Sólo bajo solicitud expresa",
        ],
        c: 2,
        exp: "El prospecto debe estar permanentemente disponible al público inversionista (LFI y disposiciones CNBV).",
      },
      {
        q: "El perfil del inversionista sirve para:",
        o: [
          "Calcular el ISR del cliente",
          "Determinar el régimen fiscal del fondo",
          "Adecuar las recomendaciones de inversión a su tolerancia al riesgo",
          "Establecer el monto mínimo de comisión",
        ],
        c: 2,
        exp: "El perfilamiento permite asegurar que las recomendaciones sean acordes al objetivo, horizonte y tolerancia al riesgo del inversionista.",
      },
    ],
  },

  pricing: {
    eyebrowTitle1: "Un solo precio",
    eyebrowTitle2: "Acceso total",
    eyebrowSubtitle:
      "Sin planes confusos ni permanencia. Todo el simulador, los +2,000 reactivos y las explicaciones detalladas por una mensualidad simple.",
    plan: {
      name: "Plan Examen Aprobado",
      price: 249,
      currency: "MX$",
      period: "/mes",
      description: "Acceso completo al temario, banco de reactivos y simuladores.",
      features: [
        "Temario completo Serie 100 (9 módulos)",
        "+2,000 reactivos de práctica",
        "Simuladores ilimitados tipo examen real",
        "Explicación detallada en cada reactivo citando la norma",
        "Estadísticas y progreso por módulo",
        "Soporte prioritario por correo",
      ],
      ctaLabel: "Suscribirme Ahora",
      benefitsList: [
        "Simulador real Figura 1 (100 reactivos / 120 min)",
        "Simuladores ilimitados",
        "+2,000 reactivos de práctica",
        "Explicación detallada en cada reactivo",
        "Acceso multi-dispositivo (web, tablet, móvil)",
        "Temario AMIB Serie 100 completo",
        "Análisis de progreso por módulo",
        "Soporte prioritario",
      ],
    },
  },

  faq: {
    eyebrow: "Preguntas Frecuentes",
    title: "Todo lo que necesitas saber",
    subtitle: "Respuestas claras a las dudas más comunes antes de inscribirte.",
    items: [
      {
        question: "¿Necesito experiencia previa en finanzas?",
        answer:
          "No. AMIBFigura1 está diseñado para aspirantes desde cero. El temario te lleva paso a paso desde los conceptos básicos del sistema financiero hasta la regulación bursátil de la CNBV.",
      },
      {
        question: "¿Qué temas cubre exactamente la plataforma?",
        answer:
          "Los 9 módulos del temario oficial Serie 100: ética y normatividad AMIB, marco legal LMV/LFI, economía y sistema financiero mexicano, fondos de inversión, mercado de deuda, mercado de capitales y derivados, perfil del inversionista, PLD/FT y matemáticas financieras con valuación.",
      },
      {
        question: "¿Cuántos reactivos incluye el banco de preguntas?",
        answer:
          "Más de 2,000 reactivos tipo examen oficial, con explicación detallada citando la regulación aplicable (LMV, LFI, DCG de la CNBV, Código de Ética AMIB, lineamientos PLD/FT).",
      },
      {
        question: "¿El contenido está actualizado con la CNBV y AMIB?",
        answer:
          "Sí. Mantenemos el banco de reactivos y el temario alineados a las disposiciones vigentes de la CNBV, Banxico, SHCP y al programa Serie 100 de la AMIB.",
      },
      {
        question: "¿El simulador es como el examen real?",
        answer:
          "Sí. Replicamos el formato Serie 100: 100 reactivos, 120 minutos, ponderación por módulo y calificación instantánea idéntica al examen oficial AMIB.",
      },
      {
        question: "¿Puedo cancelar la suscripción cuando quiera?",
        answer:
          "Sí, sin contratos ni permanencia. Cancelas con un clic desde tu panel y conservas el acceso hasta el final del periodo pagado.",
      },
      {
        question: "¿Esta plataforma me da la certificación oficial?",
        answer:
          "No. Somos una plataforma independiente que te prepara para aprobar. La certificación oficial la emite la AMIB tras presentar y aprobar el examen Figura 1.",
      },
      {
        question: "¿Puedo estudiar desde mi celular?",
        answer:
          "Sí. La plataforma es 100% responsive: estudia desde computadora, tablet o smartphone, retomando exactamente donde lo dejaste.",
      },
      {
        question: "¿Cuánto tiempo necesito para prepararme?",
        answer:
          "Recomendamos entre 4 y 8 semanas dedicando 1–2 horas diarias, dependiendo de tu base previa en finanzas y regulación.",
      },
    ],
  },

  testimonials: {
    eyebrow: "Qué incluye",
    title: "Lo que incluye la plataforma",
    subtitle:
      "Herramientas concretas para preparar el examen AMIB Figura 1 (Serie 100).",
    items: [
      {
        icon: "📚",
        title: "+2,000 reactivos con explicación",
        description:
          "Cada pregunta incluye una explicación detallada que cita la regulación aplicable: LMV, LFI, DCG de la CNBV y Código de Ética AMIB.",
      },
      {
        icon: "⏱️",
        title: "Simulacros tipo examen oficial ilimitados",
        description:
          "100 reactivos y 120 minutos por simulacro, con ponderación por módulo y calificación instantánea.",
      },
      {
        icon: "📊",
        title: "Estadísticas y seguimiento de progreso",
        description:
          "Visualiza tu avance por módulo e identifica qué reforzar antes de presentar el examen.",
      },
      {
        icon: "🌐",
        title: "Acceso 24/7 en cualquier dispositivo",
        description:
          "Estudia desde computadora, tablet o celular, retomando exactamente donde lo dejaste.",
      },
    ],
  },

  ai: {
    chatTitle: "Tutor Inteligente AMIB Figura 1",
    welcomeMessage:
      "¡Hola! Soy tu tutor experto en la Serie 100 AMIB. ¿Tienes dudas sobre fondos de inversión, ética o normativa CNBV? Pregúntame.",
    systemInstructionDefault:
      "Eres un experto en regulación CNBV y certificación AMIB Serie 100 para Promotores de Fondos de Inversión. Responde de forma concisa y educativa.",
    systemInstructionTutor:
      "Eres un tutor experto en el examen AMIB Figura 1. Sé directo, amable y cita disposiciones cuando sea relevante.",
    casePromptTemplate: (topicTitle) =>
      `Genera un caso práctico corto (máx 100 palabras) sobre "${topicTitle}" para un Promotor de Fondos de Inversión en México. Incluye un dilema ético o regulatorio y pregunta qué debería hacer el promotor.`,
    caseSystemInstruction: "Eres un instructor de la AMIB en México.",
    inputPlaceholder: "Escribe tu duda regulatoria...",
  },

  exam: {
    simulatorQuestions: 100,
    simulatorDurationMinutes: 120,
    topicWeights: [
      { id: "t1", weight: 0.15 }, // Ética y Normatividad
      { id: "t2", weight: 0.12 }, // Marco Legal del Mercado de Valores
      { id: "t3", weight: 0.10 }, // Economía y Sistema Financiero
      { id: "t4", weight: 0.15 }, // Fondos de Inversión — Estructura
      { id: "t5", weight: 0.10 }, // Mercado de Deuda
      { id: "t6", weight: 0.10 }, // Capitales y Derivados
      { id: "t7", weight: 0.10 }, // Perfil del Inversionista
      { id: "t8", weight: 0.10 }, // PLD/FT
      { id: "t9", weight: 0.08 }, // Matemáticas Financieras y Riesgos
    ],
    passingScore: 70,
    simulatorTitle: "Simulación Real Figura 1",
  },

  uiCopy: {
    loading: "Cargando...",
    navHome: "Dashboard",
    navStudy: "Temario Serie 100",
    navStudyShort: "Temario Oficial",
    navQuizzes: "Práctica por temas",
    navQuizzesShort: "Práctica por Tema",
    navSimulator: "Simulador Real",
    navBilling: "Mi Plan",
    sidebarPrincipal: "Principal",
    sidebarSimulation: "Simulación",
    bannerCta: "🚀 Desbloquea el Simulador Real y Práctica por Temas",
    bannerCtaButton: "Premium",
    legalLastUpdate: "Última actualización: 10 de junio de 2026",
    cta: {
      finalSectionTitle: "¿Listo para aprobar tu Figura 1?",
      finalSectionSubtitle:
        "Prepara tu Serie 100 con +2,000 reactivos, simulacros ilimitados y explicación en cada pregunta. Acceso inmediato, sin permanencia.",
      finalSectionPrimary: "Comenzar ahora",
      finalSectionSecondary: "Hablar con ventas",
      finalSectionFooter: "✨ Acceso inmediato · Cancela cuando quieras",
    },
    masterDomainLabel: "Dominio del Temario Serie 100",
    statsCards: {
      generalProgress: "Progreso General",
      sectionsRead: "Secciones Leídas",
      examsTaken: "Simulacros Realizados",
      bestScore: "Puntaje Máx.",
    },
    auth: {
      welcomeTitle: "Bienvenido",
      welcomeSubtitle: "Inicia sesión para continuar tu certificación",
      registerTitle: "Crear cuenta",
      registerSubtitle: "Comienza tu camino a la Figura 1",
    },
    landing: {
      productNavLabel: "Producto",
      productLinks: [
        { href: "#features", label: "Características" },
        { href: "#pricing", label: "Precios" },
        { href: "#demo", label: "Simulador" },
        { href: "#testimonials", label: "Qué incluye" },
      ],
    },
  },

  legal: {
    companyName: "AMIBFigura1 by MIVX",
    companyShortName: "AMIBFigura1",
    governingLaw: "México",
    privacyContactEmail: "go@mivx.com",
  },
};

export default siteConfig;
